import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { inviteService } from '@/services/InviteService'
import { inviteKeys } from '@/hooks/queryKeys'
import type { InviteListDto } from '@lib/dto/invite.dto'

/**
 * Load every invite. Returns the raw TanStack Query result so callers can drive
 * loading / empty / error states from `isPending`, `isError`, and `data`.
 *
 * `staleTime` is short because invite status is time-sensitive: a PENDING
 * invite becomes EXPIRED on its own, with no mutation to invalidate the cache.
 */
export function useInvites(): UseQueryResult<InviteListDto> {
  return useQuery({
    queryKey: inviteKeys.list(),
    queryFn: () => inviteService.list(),
    staleTime: 15_000,
  })
}
